import React from "react";

const ViewTitle = ({title, description}) =>{
    return(
        <>        
            <h3 className="form-title">{title} </h3>
            <p className="form-sub-title">
                {description}
            </p>
        </>

    )
}

export default ViewTitle;